import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { marketsStore } from '../../../store/marketsStore';

export const HiLoButtonsBlock = observer(({ innerComp: InnerComp }) => {
  const { hiOrLoMarket, setSelectedMarket } = marketsStore;

  const cardData = useMemo(() => {
    const cardHiLoData = {};
    hiOrLoMarket.forEach((cardHiLoType) => {
      cardHiLoData[cardHiLoType.betType] = cardHiLoType;
    });

    return cardHiLoData;
  }, [hiOrLoMarket]);

  const handleSetMarketData = (marketData) => {
    setSelectedMarket(marketData);
  };

  return <InnerComp cardData={cardData} onSetMarketData={handleSetMarketData} />;
});
